<div class="m-asm-customers-search-result">
  <div class="a-person" [ngClass]="{'ecommerce' : customer.ecommerce}"
       vTp="item{{index}}"
       *ngFor="let customer of  customers; let index=index;"
       (click)="selectedCustomer(customer)"
  >
    <div class="a-name">
      {{customer.name}}
    </div>
    <div class="a-email">
      {{customer.email}}
    </div>
    <div class="a-tel">
        {{customer.tel}}
    </div>
    <div class="a-address a-field">
      {{customer.street}} {{customer.town}}
    </div>
  </div>

  <div class="a-no-results"
       *ngIf="!customers.length"
  >
    {{'asm.no.results' | translate}}
  </div>
</div>
